export default "<ion-content>\r\nNada por aquí?\r\n</ion-content>";